var Product = new Vue({
    el: '.product .main.vue',
    data: {
        variants: window.variants,
        selectedVariant: window.selectedVariant || null,
        bundles: window.selectedVariant.bundles || [],
        selectedVariantId: null,
        ready: false,
        products: [],
        productType: window.productType || '',
        colours: [],
        productOptions: window.productOptions || [],
        currentPallet: 'similar',
        palettes: []
    },
    computed: {
        utils() {
            return Utils;
        },
        glitterColourSpecs() {
            let specs = {};
            let colour_index = window.productOptions.findIndex(option => option === 'Colour' || option === 'Glitter Colour');
            let size_index = window.productOptions.findIndex(option => option === 'Size');
            let weight_index = window.productOptions.findIndex(option => option === 'Weight');
            let shape_index = window.productOptions.findIndex(option => option === 'Shape');
            specs = {
                'colour':  colour_index !== -1 ? this.selectedVariant.options[colour_index] : '',
                'size': size_index !== -1 ? this.selectedVariant.options[size_index] : '',
                'weight': weight_index !== -1 ? this.selectedVariant.options[weight_index] : '',
                'shape': shape_index !== -1 ? this.selectedVariant.options[shape_index] : ''

            };
            return specs;
        },
        colourMetaObject() {
            const _this = this;
            let colour_index = window.productOptions.findIndex(option => option === 'Colour' || option === 'Glitter Colour');
            const colour_data = _this.colours.find(c => c.title.toLowerCase() === _this.selectedVariant.options[colour_index].toLowerCase());
            if ( ! colour_data ) {
                return null;
            }

            const tone = colour_data.tone.toLowerCase();
            const colour_metaobject = this.colours.find(c => {
                let tone_found = false;
                let size_found = false;
                let type_found = false;
                let shape_found = ! _this.glitterColourSpecs.shape;

                if (tone === 'Holographics') {
                    tone_found = c.title.includes('Holographic');
                } else if (tone === 'Metallics') {
                    tone_found = c.title.includes('Metallic');
                } else if (tone === 'Fluorescents') {
                    tone_found = c.title.includes('Fluorescent');
                } else {
                    tone_found = c.tone.toLowerCase() === tone.toLowerCase();
                }

                if ( _this.productType == 'Ready Mixed Glitter Grout' ) {

                    type_found = c.type.toLowerCase() === 'one-size';
                    size_found = c.size.toLowerCase() === 'ultrafine';

                } else {

                    size_found = ( ! _this.glitterColourSpecs.size ) || 
                                (  _this.glitterColourSpecs.size.toLowerCase().includes( 'shaped' ) && c.size.toLowerCase() === 'shaped' ) || 
                                ( c.size.toLowerCase() === _this.glitterColourSpecs.size.toLowerCase() );

                    if ( _this.productType.toLowerCase().includes('multi') ) {
                        type_found = c.type.toLowerCase() === 'multi-size';
                    }
                    else if ( _this.productType.toLowerCase().includes('mixed') ) {
                        type_found = c.type.toLowerCase() === 'mixed';
                    } else {
                        type_found = c.type.toLowerCase() === 'one-size';
                    }

                } 

                if ( _this.glitterColourSpecs.shape ) {
                    shape_found = c.shape && c.shape.toLowerCase() == _this.glitterColourSpecs.shape.toLowerCase() || false;
                }

                return c.title.toLowerCase() === _this.glitterColourSpecs.colour.toLowerCase() && tone_found && size_found && type_found && shape_found;
            });

            return colour_metaobject;
        }
    },
    watch: {
        currentPallet(newPallet) {
            this.handlePalletChange();
        }
    },
    methods: {
        handlePalletChange() {

        },
        getLocalizedField(bundle, field) {
            const locale = window.locale || 'uk';
            return bundle[`${locale}_${field}`] || [];
        },     
        getSizeImage(size) {
            const _this = this;
            const colour_metaobject = this.colours.find(c => {
                let tone_found = c.tone === _this.colourMetaObject.tone;
                let type_found = c.type === _this.colourMetaObject.type;
                let size_found =  ( c.size.toLowerCase() === size.toLowerCase() ) || ( _this.glitterColourSpecs.size.toLowerCase().includes( 'shaped' ) && c.size.toLowerCase() === 'shaped' );
                let colour_found = c.title == _this.colourMetaObject.title

                return tone_found && type_found && size_found && colour_found;
            });
            return colour_metaobject ? colour_metaobject.image : '';
        },
        getColourTag(tags) {
            if (!tags) return '';
            const tag = tags.find(t => t.startsWith('Colour_'));
            return tag ? tag.replace('Colour_', '') : '';
        },
        getColourOptions(tone) {
            const _this = this;
            let options = [];
            if (window.productColourOptions) {
                window.productColourOptions.forEach(colour => {
                    if (colour.tags && colour.tags.includes('Tone_' + tone)) {
                        colour.colour = this.getColourTag(colour.tags);  
                        let proceed = true; 
                        const shape_index = colour.options.findIndex(option => option.toLowerCase() == 'shape');

                        if ( _this.glitterColourSpecs.shape ) {
                            proceed = false;
                            if ( shape_index > -1 && colour.variant_options[ shape_index ].toLowerCase() === _this.glitterColourSpecs.shape.toLowerCase() ) {
                                proceed = true;
                            }
                        }

                        if ( proceed ) {
                            let colour_metaobject = _this.colours.find(c => {
                                let tone_found = false;
                                let size_found = false;
                                let type_found = false;
                                let shape_found = shape_index == -1;

                                if (tone === 'Holographics') {
                                    tone_found = c.title.includes('Holographic');
                                } else if (tone === 'Metallics') {
                                    tone_found = c.title.includes('Metallic');
                                } else if (tone === 'Fluorescents') {
                                    tone_found = c.title.includes('Fluorescent');
                                } else if (tone === 'Glows') {
                                    tone_found = c.title.includes('Glow');
                                } else {
                                    tone_found = c.tone.toLowerCase() === tone.toLowerCase();
                                }

                                if ( _this.productType == 'Ready Mixed Glitter Grout' ) {
                                    
                                    type_found = c.type.toLowerCase() === 'one-size';
                                    size_found = c.size.toLowerCase() === 'ultrafine';

                                } else {

                                    if ( ! _this.glitterColourSpecs.size ) {
                                        size_found = true;
                                    } else {
                                        size_found = c.size.toLowerCase() === _this.glitterColourSpecs.size.toLowerCase();
                                    }

                                    if ( ! size_found ) {
                                        if ( colour.variant_options.find(item => item.toLowerCase().includes( 'shaped' )) ) {
                                            size_found = true;
                                        } else if ( _this.glitterColourSpecs.size.toLowerCase().includes( 'shaped' ) ) {
                                            size_found = c.size.toLowerCase() === 'ultrafine';
                                        }
                                    }

                                    if ( _this.productType.toLowerCase().includes('multi') ) {
                                        type_found = c.type.toLowerCase() === 'multi-size';
                                    }
                                    else if ( _this.productType.toLowerCase().includes('mixed') ) {
                                        type_found = c.type.toLowerCase() === 'mixed';
                                    } else {
                                        type_found = c.type.toLowerCase() === 'one-size';
                                    }

                                } 
                                
                                if ( shape_index > -1 ) {
                                    shape_found = c.shape && c.shape.toLowerCase() == colour.variant_options[ shape_index ].toLowerCase() || false;
                                }

                                return c.title.toLowerCase() === colour.colour.toLowerCase() && tone_found && size_found && type_found && shape_found;
                            });

                            colour.image = colour_metaobject ? colour_metaobject.image : '';

                            if ( colour.image ) {
                                options.push(colour);
                            }
                        }
                    }
                });
            }
            setTimeout(() => {
                _this.refreshTones(tone.toLowerCase());
            }, 1);
            return options;
        },
        refreshTones(tone) {
            const $tone = $(document).find( `.product .overview .content .blocks .block .fields .attributes .attribute.color .content .modal .content .tones .tone[data-color="${tone}"]` );
            if ( $tone.find( '.terms .term:not(.hidden)' ).length > 0 ) {
                $tone.removeClass( 'hidden' );
            } else {
                $tone.addClass( 'hidden' );
            }
        },
        fetchPalettes() {
            return fetch(window.palettesURL)                
                .then(response => response.json())
                .catch(error => {
                    console.error('Error fetching colours:', error);
                    return [];
                });
        },
        fetchColours() {        
            return fetch('https://alt.hemway.com/api/index.php/shopify/colours', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(response => response.json())
            .catch(error => {
                console.error('Error fetching colours:', error);
                return [];
            });
        },
        getBundles(variant = null) {
            const _this = this;
            if ( variant ) {
                this.selectedVariant = variant;
                this.selectedVariantId = variant.id;  
                this.$set( this, 'bundles', variant.bundles ); 
            } else {
                this.selectedVariant = window.selectedVariant;
                this.selectedVariantId = this.selectedVariant.id;  
                this.$set( this, 'bundles', this.selectedVariant.bundles ); 
            }
            _this.bundles.forEach((bundle, index) => {
                _this.generateBundleProducts(index);
            });
        },
        getBundlePrice(bundle) {
            return bundle.products.reduce((sum, p) => {
            let price = typeof p.price_formatted === 'string'
                ? parseFloat(p.price_formatted.replace(/[^0-9.]/g, ''))
                : p.price_formatted;
            return sum + (isNaN(price) ? 0 : price);
            }, 0);
        },
        getProductIds(bundle) {
            return bundle.products.map(p => p.id).reverse().join(',');
        },
        generateBundleProducts(index) {
            this.ready = false;
            const _this = this;
            let items = [];
            const bundle = this.bundles[index];
            let products = bundle.products || [];

            products.forEach((product, product_index) => {
                let product_id = product.product_id;
                if (product_id && !items.includes(product_id)) {
                    items.push(product_id);
                }
            });

            const queryString = items
                .map(item => `id:${item}`)
                .join(' OR ');
            const template = 'products';
            const url = `${window.routes.searchUrl}?view=${template}&q=${queryString}`;

            fetch(url, {
                credentials: 'same-origin',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(response => {
                products.forEach((product, product_index) => {
                    if (!response.find(p => p.product_id == product.product_id)) {
                        const dataIndex = response.findIndex(item => product.product_id == item.id);
                        if (dataIndex === -1) {
                            console.warn('Product not found in response:', product);
                            return;
                        }
                        const data = response[dataIndex];
                        const url = data.url.includes('?') ? `${data.url}&variant=${product.id}` : `${data.url}?variant=${product.id}`;
                        data.url = url;
                        const mergedProduct = {
                            ...data,
                            ..._this.bundles[index].products[product_index],
                            ...product
                        };
                        _this.$set(_this.bundles[index].products, product_index, mergedProduct);
                        _this.products.push(mergedProduct);
                    }
                });
                _this.ready = _this.bundles[index].products.length > 0;
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
        },
        money(value) {
            if (typeof value !== 'number' || isNaN(value)) return value;
            return '£' + value.toFixed(2);
        },
        renderVariantColours() {
            const _this = this;
            const colour_index = _this.productOptions.findIndex(option => option.toLowerCase() == 'colour' || option.toLowerCase() == 'glitter colour');
            const shape_index = _this.productOptions.findIndex(option => option.toLowerCase() == 'shape');

            _this.variants.forEach(variant => {
                const colour_data = _this.colours.find(c => c.title.toLowerCase() === variant.options[colour_index].toLowerCase());
                if ( colour_data ) {
                    const tone = colour_data.tone.toLowerCase();
                    let $el = $(document).find( '.product .overview .content .blocks.three .block .fields .attributes .attribute.color .content .modal .content .tones' );
                    if ( $el.find(`.tone[data-color='${tone}']`).length == 0 ) {
                        $el.append(`
                            <div data-color="${tone}" class="tone color hidden">
                                <div class="title">
                                    <div class="swatch ${tone}"></div> 
                                    <h4 class="two">${colour_data.tone}</h4>
                                </div> 
                                <div class="content"> 
                                    <div class="terms"></div>
                                </div>
                        </div>`);
                    }
                    $el = $(document).find( `.product .overview .content .blocks.three .block .fields .attributes .attribute.color .content .modal .content .tones .tone[data-color="${tone}"]` );

                    const colour_metaobject = _this.colours.find(c => {
                        let tone_found = false;
                        let size_found = false;
                        let type_found = false;
                        let shape_found = shape_index == -1;

                        if (colour_data.tone === 'Holographics') {
                            tone_found = c.title.includes('Holographic');
                        } else if (colour_data.tone === 'Metallics') {
                            tone_found = c.title.includes('Metallic');
                        } else if (colour_data.tone === 'Fluorescents') {
                            tone_found = c.title.includes('Fluorescent');
                        } else if (colour_data.tone === 'Glows') {
                            tone_found = c.title.includes('Glow');
                        } else {
                            tone_found = c.tone.toLowerCase() === tone;
                        }

                        if ( _this.productType == 'Ready Mixed Glitter Grout' ) {
                            
                            type_found = c.type.toLowerCase() === 'one-size';
                            size_found = c.size.toLowerCase() === 'ultrafine';

                        } else {

                            if ( ! _this.glitterColourSpecs.size ) {
                                size_found = true;
                            } else {
                                size_found = c.size.toLowerCase() === _this.glitterColourSpecs.size.toLowerCase();
                            }

                            if ( ! size_found ) {
                                if ( variant.options.find(item => item.toLowerCase().includes( 'shaped' )) ) {
                                    size_found = true;
                                } else if ( _this.glitterColourSpecs.size.toLowerCase().includes( 'shaped' ) ) {
                                    size_found = c.size.toLowerCase() === 'ultrafine';
                                }
                            }

                            if ( _this.productType.toLowerCase().includes('multi') ) {
                                type_found = c.type.toLowerCase() === 'multi-size';
                            }
                            else if ( _this.productType.toLowerCase().includes('mixed') ) {
                                type_found = c.type.toLowerCase() === 'mixed';
                            } else {
                                type_found = c.type.toLowerCase() === 'one-size';
                            }

                        } 
                        
                        if ( shape_index > -1 ) {
                            shape_found = c.shape && c.shape.toLowerCase() == variant.options[ shape_index ].toLowerCase() || false;
                        }

                        return c.title.toLowerCase() === variant.options[ colour_index ].toLowerCase() && tone_found && size_found && type_found && shape_found;
                    });

                    if ( colour_metaobject && colour_metaobject.image ) {
                        const colour = colour_metaobject.title;
                        if ( $el.find( `.terms .term[data-colour="${colour}"]` ).length == 0 ) {
                            $el.find('.terms').append(`
                                <div class="term" data-id="${window.currentProductId}" data-variant_id="${variant.id}" data-colour="${colour}">
                                    <a href="${window.productUrl}?variant=${variant.id}">
                                        <div class="swatch"
                                            data-lazy-location="${colour_metaobject.image}"
                                            style="background-image: url('${colour_metaobject.image}');"
                                            role="img"
                                            aria-label="${colour_metaobject.title}"></div>
                                            <div class="title">
                                                <h5 class="three">${colour}</h5>
                                            </div>
                                    </a>
                                </div>
                            `);
                        }
                    }

                    setTimeout(() => {
                        _this.refreshTones(tone);
                    },  3);
                }
            });
        }
    },
    mounted() {      
        const _this = this;
        $( '.product .overview .default.hidden' ).remove();
        this.fetchColours().then(data => {
            _this.colours = data.results || [];
            if ( _this.colourMetaObject && _this.colourMetaObject.shape ) {
                setTimeout(() => {
                    _this.renderVariantColours();
                }, 2);
            }                
        });
        this.fetchPalettes().then(data => {
            const item = data.find(item => item.colour.colour === window.productColour && _this.variants.find(v => v.id == item.colour.id));
            if (item) {
                let palettes = {
                    colour: item.colour,
                    keys: {
                        'similar': {
                            'title': 'Similar',
                            'description': `Similar schemes combine shades that naturally sit close in tone, creating a subtle harmony. The result is a soothing, well-balanced palette that feels seamless and beautifully put together.`,
                            'items': item['similar'].items
                        },
                        'tonal': {
                            'title': 'Tonal',
                            'description': `Tonal schemes layer one colour in different strengths, creating a sleek, understated look that feels effortlessly coordinated.`,
                            'items': item['tonal'].items
                        },
                        'complementary': {
                            'title': 'Complementary',
                            'description': `Complementary schemes pair shades with contrasting undertones, creating a bold yet harmonious look that brings energy and balance to your space.`,
                            'items': item['complementary'].items
                        },
                        'white-pairings': {
                            'title': 'White Pairings',
                            'description': `Blending gentle shades of white creates a calm, expansive atmosphere that feels both timeless and effortless.`,
                            'items': item['white-pairings'].items
                        }
                    }
                };
                _this.palettes = palettes;
            }
        });
    }
});